import ConnectedPaymentInfoModule from './ConnectedPaymentInfoModule';

export default ConnectedPaymentInfoModule;
